import { combineEpics } from 'redux-observable';

import { resubscribeUserAndAvailabilityUpdatesEpic } from './userAndAvailabilityUpdates';
import { resubscribeEstimatedTimeUpdatesEpic } from './estimatedTimeUpdates';
import { resubscribeServiceConfigUpdatesEpic } from './serviceConfigUpdates';


export default combineEpics(
  resubscribeServiceConfigUpdatesEpic,
  resubscribeUserAndAvailabilityUpdatesEpic,
  resubscribeEstimatedTimeUpdatesEpic,
);
